/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * UpSmith Dev API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from "@tanstack/react-query";
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult,
} from "@tanstack/react-query";
import type { HTTPValidationError, PantheonUserSignup } from ".././schema";
import { axiosInstance } from "../../lib/axios";
import type { ErrorType } from "../../lib/axios";

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

/**
 * @summary Create Pantheon Signup
 */
export const createPantheonSignup = (
  pantheonUserSignup: PantheonUserSignup,
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<unknown>(
    {
      url: `/api/v1/signup`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: pantheonUserSignup,
      signal,
    },
    options
  );
};

export const getCreatePantheonSignupMutationOptions = <
  TData = Awaited<ReturnType<typeof createPantheonSignup>>,
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { data: PantheonUserSignup },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const mutationKey = ["createPantheonSignup"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createPantheonSignup>>,
    { data: PantheonUserSignup }
  > = (props) => {
    const { data } = props ?? {};

    return createPantheonSignup(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: PantheonUserSignup },
    TContext
  >;
};

export type CreatePantheonSignupMutationResult = NonNullable<
  Awaited<ReturnType<typeof createPantheonSignup>>
>;
export type CreatePantheonSignupMutationBody = PantheonUserSignup;
export type CreatePantheonSignupMutationError = ErrorType<HTTPValidationError>;

/**
 * @summary Create Pantheon Signup
 */
export const useCreatePantheonSignup = <
  TData = Awaited<ReturnType<typeof createPantheonSignup>>,
  TError = ErrorType<HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    TData,
    TError,
    { data: PantheonUserSignup },
    TContext
  >;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<
  TData,
  TError,
  { data: PantheonUserSignup },
  TContext
> => {
  const mutationOptions = getCreatePantheonSignupMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Validate Pantheon Signup
 */
export const validatePantheonSignup = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<unknown>(
    { url: `/api/v1/validate`, method: "POST", signal },
    options
  );
};

export const getValidatePantheonSignupMutationOptions = <
  TData = Awaited<ReturnType<typeof validatePantheonSignup>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, void, TContext>;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const mutationKey = ["validatePantheonSignup"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof validatePantheonSignup>>,
    void
  > = () => {
    return validatePantheonSignup(requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    void,
    TContext
  >;
};

export type ValidatePantheonSignupMutationResult = NonNullable<
  Awaited<ReturnType<typeof validatePantheonSignup>>
>;

export type ValidatePantheonSignupMutationError = ErrorType<unknown>;

/**
 * @summary Validate Pantheon Signup
 */
export const useValidatePantheonSignup = <
  TData = Awaited<ReturnType<typeof validatePantheonSignup>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, void, TContext>;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<TData, TError, void, TContext> => {
  const mutationOptions = getValidatePantheonSignupMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * @summary Award Points For Video
 */
export const awardPointsForVideo = (
  options?: SecondParameter<typeof axiosInstance>,
  signal?: AbortSignal
) => {
  return axiosInstance<unknown>(
    { url: `/api/v1/actions/award-points-for-video`, method: "POST", signal },
    options
  );
};

export const getAwardPointsForVideoMutationOptions = <
  TData = Awaited<ReturnType<typeof awardPointsForVideo>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, void, TContext>;
  request?: SecondParameter<typeof axiosInstance>;
}) => {
  const mutationKey = ["awardPointsForVideo"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof awardPointsForVideo>>,
    void
  > = () => {
    return awardPointsForVideo(requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    void,
    TContext
  >;
};

export type AwardPointsForVideoMutationResult = NonNullable<
  Awaited<ReturnType<typeof awardPointsForVideo>>
>;

export type AwardPointsForVideoMutationError = ErrorType<unknown>;

/**
 * @summary Award Points For Video
 */
export const useAwardPointsForVideo = <
  TData = Awaited<ReturnType<typeof awardPointsForVideo>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, void, TContext>;
  request?: SecondParameter<typeof axiosInstance>;
}): UseMutationResult<TData, TError, void, TContext> => {
  const mutationOptions = getAwardPointsForVideoMutationOptions(options);

  return useMutation(mutationOptions);
};
